module.exports = __webpack_public_path__ + "static/media/AddLogoWite.1e5bc040.svg";